import { pipelineId, writekey, clusterId } from '../fixture-ids';

export const pipelineLegacyAlternates = {};

export const pipelineLegacyFixtures = {
  PIPELINE_CREATED: {
    action: 'PIPELINE_CREATED',
    debugData: { pipelineId, pipelineName: 'Web Analytics', writekey, clusterId },
  },
  PIPELINE_UPDATED: {
    action: 'PIPELINE_UPDATED',
    debugData: { pipelineId, pipelineName: 'Web Analytics' },
  },
  PIPELINE_DELETED: {
    action: 'PIPELINE_DELETED',
    debugData: { pipelineId, pipelineName: 'Web Analytics' },
  },
};
